// The Amazon overview's pages, in the order its nav lists them, and the path each lives at
// (docs/Y2026-Q4/design-amazon-item-owners.md section 2.1).
import type { NavIconName } from "../../layouts/NavIcon";

export const OVERVIEW_PATH = "/amazon-overview";

export const OVERVIEW_PAGES = [
  { id: "portfolio", label: "Portfolio status", icon: "amazon-portfolio" },
  { id: "sites", label: "Site details", icon: "amazon-site" },
  { id: "needed", label: "Needed from Amazon", icon: "amazon-needed" },
  { id: "eusdr", label: "EUSDR questions", icon: "amazon-eusdr" },
  { id: "process", label: "Process overview", icon: "amazon-process" },
] as const satisfies readonly {
  id: string;
  label: string;
  icon: NavIconName;
}[];

export type OverviewPageId = (typeof OVERVIEW_PAGES)[number]["id"];

export const pagePath = (id: OverviewPageId): string => `${OVERVIEW_PATH}/${id}`;

export const pageLabel = (id: OverviewPageId): string =>
  OVERVIEW_PAGES.find((p) => p.id === id)?.label ?? "";

/** A building's Site details page, by the code the page shows it under. */
export const sitePath = (code: string): string =>
  `${pagePath("sites")}/${encodeURIComponent(code)}`;

/** Only the edit switch rides from page to page; a page's own filters stay with it. */
export const carriedSearch = (search: string): string => {
  const edit = new URLSearchParams(search).get("edit");
  return edit ? `?edit=${encodeURIComponent(edit)}` : "";
};
